import {
    PORTFOLIO_ANALYZE_PATH,
    API_BASE_URL,
    ASSETS_BASE_PATH,
    FILTER_BASE_PATH,
    BROKERS_BASE_PATH,
    CURRENCY_PATH, LOADERS_BASE_PATH,
    SECURITY_SEARCH_PATH,
    TOKEN, TRADING_ADMIN_PATH, TRADING_PATH
} from "../constants";
import axios from 'axios';
import qs from 'qs';


const getInstance = (timeout) => {
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem(TOKEN)
    };

    return axios.create({
        baseURL: API_BASE_URL,
        timeout: timeout,
        headers: headers,
        withCredentials: true
    });
}

const get = (url, options, timeout = 15000) => {
    const instance = getInstance(timeout);

    return instance.get(url, options)
        .then(response => {
            if (response.status !== 200) {
                return Promise.reject(response);
            }
            return response.data;
        })
        .catch(response => {
            return Promise.reject(response);
        });
}


const post = (url, values, timeout = 15000) => {
    const instance = getInstance(timeout);

    return instance.post(url, values).then(response => {
        if (response.status !== 200 && response.status !== 201) {
            return Promise.reject(response);
        }
        return response.data;
    });
}

const put = (url, values, timeout = 15000) => {
    const instance = getInstance(timeout);

    return instance.put(url, values)
        .then(response => {
            if (response.status !== 200) {
                return Promise.reject(response);
            }
            return response.data;
        })
        .catch(response => {
            return Promise.reject(response);
        });
}

const patch = (url, values, timeout = 15000) => {
    const instance = getInstance(timeout);
    return instance.patch(url, values);
}

const del = (url, options, timeout = 15000) => {
    const instance = getInstance(timeout);

    return instance.delete(url, options).then(response => {
        if (response.status !== 200) {
            return Promise.reject(response);
        }
        return response.data;
    });
}


const orderDirectionConverter = (order) => {
    switch (order) {
        case 'descend' : return 'desc';
        case 'ascend' : return 'asc';
        default: return '';
    }
}

const fieldsFilterToParams = (fieldsFilter) => {
    const fieldParams = {};
    Object.keys(fieldsFilter).filter(item => fieldsFilter[item]).forEach((item) => {
        fieldParams[item] = fieldsFilter[item].join(',');
    });
    return fieldParams;
}


/********************************************************
 * BONDS
 *
 */
export const bonds = ({durations, rates, reliability, bondTypes, active, offerTypes, additional}, pagination, fieldsFilter, sorting) => {
    const {field = '', order = ''} = sorting;
    let params = {
        rates: rates.join(','),
        durations: durations.join(','),
        reliability: reliability.join(','),
        types: bondTypes.join(','),
        active: active.join(','),
        offerTypes: offerTypes.join(','),
        additional: additional.join(','),
        size: pagination.pageSize,
        page: pagination.current - 1,
        sort: `${field},${orderDirectionConverter(order)}`
    };
    if (fieldsFilter) {
        const fieldParams = {};
        Object.keys(fieldsFilter).filter(item => fieldsFilter[item]).forEach((item) => {
            fieldParams[item] = fieldsFilter[item].join(',');
        });
        params = {
            ...params,
            ...fieldParams
        };
    }

    return get(`${FILTER_BASE_PATH}/bonds`, {
        params: params
    });
}

//*************************** ASSETS *****************************************


export const assets = (activeOnly) => {
    const params = {activeOnly}
    return get(`${ASSETS_BASE_PATH}`, {params});
}

export const createAsset = (asset) => {
    return post(`${ASSETS_BASE_PATH}`, asset);
}

export const updateAsset = (asset) => {
    const {id} = asset;
    return put(`${ASSETS_BASE_PATH}/${id}`, asset);
}

export const deleteAsset = (id) => {
    return del(`${ASSETS_BASE_PATH}/${id}`);
}

export const brokers = () => {
    return get(`${BROKERS_BASE_PATH}`);
}

export const assetDetailInfo = (asset) => {
    const {id} = asset;
    return get(`${ASSETS_BASE_PATH}/${id}/details-info`);
}

export const assetTotalReturn = (assetId) => {
    return get(`${ASSETS_BASE_PATH}/${assetId}/total`);
}


export const updateReportLoaderParams = (assetId, params) => {
    return patch(`${ASSETS_BASE_PATH}/${assetId}/report-params`, params)
}


//*************************** TRANSACTIONS *****************************************

export const transactions = (assetId, pagination, filters = []) => {
    let params = {
        size: pagination.pageSize,
        page: pagination.current - 1,
        sort: `edate,desc`,
        ...fieldsFilterToParams(filters),
    };

    return get(`${ASSETS_BASE_PATH}/${assetId}/transactions`, {params});
}

export const transaction = (assetId, id) => {
    return get(`${ASSETS_BASE_PATH}/${assetId}/transactions/${id}`);
}

export const createTransaction = (assetId, transaction) => {
    return post(`${ASSETS_BASE_PATH}/${assetId}/transactions`, transaction);
}

export const updateTransaction = (assetId, transaction) => {
    const {id} = transaction;
    return put(`${ASSETS_BASE_PATH}/${assetId}/transactions/${id}`, transaction);
}

export const deleteTransaction = (assetId, transactionId) => {
    return del(`${ASSETS_BASE_PATH}/${assetId}/transactions/${transactionId}`);
}

//******************* ПОИСК *******************************************************

export const securitySearch = (value, securityType) => {
    var params = {
        value,
        securityType
    }
    return get(`${SECURITY_SEARCH_PATH}/any-match`, {params});
}

//**********************************************************************************

export const currencies = () => {
    return get(`${CURRENCY_PATH}/tracked`);
}

//**************************** ANALYZE **********************************
export const totalReturn = () => {
    return get(`${PORTFOLIO_ANALYZE_PATH}/total`);
}

export const assetTypeAllocations = () => {
    return get(`${PORTFOLIO_ANALYZE_PATH}/asset-type-allocations`);
}

export const currencyAllocations = () => {
    return get(`${PORTFOLIO_ANALYZE_PATH}/currency-allocations`);
}

//*************************** БРОКЕРСКИЕ ОТЧЕТЫ ************************************

export const uploadApiTransactions = (assetId) => {
    return post(`${LOADERS_BASE_PATH}/assets/${assetId}/api-upload`);
}

export const getLoadedTransactions = (assetId) => {
    return get(`${LOADERS_BASE_PATH}/assets/${assetId}/transactions`);
}

export const getErrorTransactions = (assetId) => {
    return get(`${LOADERS_BASE_PATH}/assets/${assetId}/error-transactions`);
}

export const deleteErrorTransactions = (assetId, transactionId) => {
    return del(`${LOADERS_BASE_PATH}/assets/${assetId}/error-transactions/${transactionId}`);
}

export const getReportLoadHistoryItems = (assetId, pagination) => {
    const {pageSize = 20, current = 1} = pagination;

    return get(`${LOADERS_BASE_PATH}/assets/${assetId}/load-history`, {
        params : {
            size: pageSize,
            page: current - 1
        },
        paramsSerializer: params => {
            return qs.stringify(params, {
                arrayFormat: 'repeat'
            });
        }
    });

}

export const saveTransactions = (assetId, transactions) => {
    return post(`${LOADERS_BASE_PATH}/assets/${assetId}/save`, transactions);
}

//*************************** СТРАТЕГИИ ************************************

export const adminStrategies = (pagination, sorting) => {
    return get(`${TRADING_ADMIN_PATH}/strategies`);
}

export const adminStrategy = (code) => {
    return get(`${TRADING_ADMIN_PATH}/strategies/${code}`);
}

export const adminUpdateStrategy = (values) => {
    return post(`${TRADING_ADMIN_PATH}/strategies`, values);
}

export const adminDeleteStrategy = (code) => {
    return del(`${TRADING_ADMIN_PATH}/strategies/${code}`);
}

export const signalEvents = (pagination, selectedStrategies) => {
    const {pageSize, current} = pagination;

    return get(`${TRADING_ADMIN_PATH}/signals/events`, {
        params : {
            strategies: selectedStrategies,
            size: pageSize,
            page: current - 1
        },
        paramsSerializer: params => {
            return qs.stringify(params, {
                arrayFormat: 'repeat'
            });
        }
    });
}

export const signalAssetEvents = (signalEventId) => {
    return get(`${TRADING_ADMIN_PATH}/signals/events/${signalEventId}/asset-events`);
}

//*************************** ТРЕЙДЕР СТРАТЕГИИ ************************************

export const strategies = (pagination = {}, sorting = {}) => {
    const {pageSize = 20, current = 1} = pagination;
    const {sort = 'code'} = sorting

    return get(`${TRADING_PATH}/strategies`, {
        params : {
            size: pageSize,
            page: current - 1,
            sort: sort
        },
        paramsSerializer: params => {
            return qs.stringify(params, {
                arrayFormat: 'repeat'
            });
        }
    });
}

export const traderStrategies = (pagination = {}, sorting = {}) => {
    const {pageSize = 20, current = 1} = pagination;
    const {sort = 'code'} = sorting

    return get(`${TRADING_PATH}/trader/strategies`, {
        params : {
            size: pageSize,
            page: current - 1,
            sort: sort
        },
        paramsSerializer: params => {
            return qs.stringify(params, {
                arrayFormat: 'repeat'
            });
        }
    });
}

export const addTraderStrategy = (values) => {
    return post(`${TRADING_PATH}/trader/strategies`, values);
}

export const editTraderStrategy = (id, values) => {
    return put(`${TRADING_PATH}/trader/strategies/${id}`, values);
}

export const delTraderStrategy = (id) => {
    return del(`${TRADING_PATH}/trader/strategies/${id}`);
}

//*************************** ТРЕЙДЕР СИГНАЛЫ СТРАТЕГИИ ************************************

export const traderStrategySignalStrategies = () => {
    return get(`${TRADING_PATH}/trader/events/strategies`);
}

export const traderStrategySignalAssets = () => {
    return get(`${TRADING_PATH}/trader/events/assets`);
}

export const traderStrategySignalEvents = (pagination = {}, selectedStrategies, selectedAssets) => {
    const {pageSize, current} = pagination;

    return get(`${TRADING_PATH}/trader/events`, {
        params : {
            strategies: selectedStrategies,
            assets: selectedAssets,
            size: pageSize,
            page: current - 1
        },
        paramsSerializer: params => {
            return qs.stringify(params, {
                arrayFormat: 'repeat'
            });
        }
    });
}

export const traderStrategySignalEventOrders = (eventId) => {
    return get(`${TRADING_PATH}/trader/events/${eventId}/orders`);
}

